module.exports = __webpack_public_path__ + "img/photo-of-sofa-near-wooden-table-3264492.e00dc7e8.jpg";